import classNames from "classnames";
import { GUSTO } from "constants/dataSource";
import { motion } from "framer-motion";
import { ReactNode, useState } from "react";
import { useHistory } from "react-router-dom";
import BillCom from "static/images/BillCom.svg";
import { BankConnection } from "types/Models/banks";
import { ConnectionLogo } from "../DataSourcesList";
import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useConstructInternalLink } from "hooks/useConstructInternalLink";
import { ConnectBillDotCom } from "components/BillComLink.tsx/ConnectBillDotCom";

export const BillComCard = ({
  name,
  description,
  isAddCard = false,
  connection,
}: {
  name: ReactNode;
  description: ReactNode;
  isAddCard?: boolean;
  connection?: BankConnection;
}) => {
  const history = useHistory();
  const { link } = useConstructInternalLink();
  const entityId = useCurrentEntityId();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showReconnect = connection && !connection.is_connection_available;

  return (
    <>
      <button
        className="all:unset"
        onClick={() =>
          history.push(link(`/${connection?.uuid}`, { includeUrl: true }))
        }
      >
        <motion.div
          layout
          className={classNames(
            "t-flex t-flex-col t-flex-1 t-items-center t-p-9 hover:t-shadow-light-100 t-shadow-light-30 t-rounded-lg t-relative t-overflow-visible t-min-h-[310px]  t-h-full t-transition-shadow",
            {
              " t-bg-i-s t-border t-border-dashed t-border-i-neutral-10 t-bg-surface-lighter-grey":
                isAddCard,
              "t-bg-surface": !isAddCard,
            }
          )}
        >
          <ConnectionLogo logoUrl={connection?.logo_url || BillCom} />
          <div className="t-mt-4 t-flex t-flex-col t-gap-2 t-justify-between t-items-center">
            <span className="t-text-subtitle-sm t-text-text-60">{name}</span>
            {description && (
              <span className="t-text-body-sm t-text-purple-55 t-text-center">
                {description}
              </span>
            )}
          </div>
          {showReconnect && (
            <div
              className="t-mt-auto t-pt-4"
              onClick={(e) => e.stopPropagation()}
            >
              <Modal.Root open={isModalOpen} onOpenChange={setIsModalOpen}>
                <Modal.Trigger asChild>
                  <Button
                    customType="primary_outlined"
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsModalOpen(true);
                    }}
                  >
                    Reconnect
                  </Button>
                </Modal.Trigger>
                <ConnectBillDotCom
                  entityId={entityId}
                  connectionId={connection.direct_base_connection_id}
                  onSuccess={() => setIsModalOpen(false)}
                />
              </Modal.Root>
            </div>
          )}
        </motion.div>
      </button>
    </>
  );
};
